// React-imports
import { ReactElement } from "react";
import Loading from "../../components/loading/loading.component";

const Knet: React.FC = (): ReactElement => {
  return (
    <div className="flex flex-col items-center min-w-full min-h-screen bg-white">
      <Loading />
    </div>
  );
};

export default Knet;
